export default __webpack_public_path__ + "billboardBackground.4049444.png";